import React from "react";
import { BADGES } from "@/data/content";

export default function Marquee() {
  const items = [...BADGES, "In-House Teams", "Transparent Reporting", "One Point of Contact"];
  const loop = [...items, ...items];
  return (
    <div className="border-y border-white/10 bg-navy py-6 overflow-hidden" data-testid="marquee">
      <div className="flex w-max animate-marquee items-center gap-24 whitespace-nowrap pr-24">
        {loop.map((t, i) => (
          <span key={i} className="flex items-center gap-24 font-serif text-3xl italic text-white/25 md:text-4xl">
            {t}
            <span className="text-gold/50 text-xl not-italic">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
